import { JsonObject } from "ta-json";

import Link from "../link";

@JsonObject()
export class ApiResource {
    [key: string]: Link;
}
